import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'app-case-practice-communicate',
	templateUrl: './case-practice-communicate.component.html',
	styleUrls: ['./case-practice-communicate.component.css']
})
export class CasePracticeCommunicateComponent implements OnInit {

	constructor() {}

	ngOnInit() {

	}
}



// WEBPACK FOOTER //
// ./src/app/case-practice-communicate/case-practice-communicate.component.ts